<template>
  <!-- BOUTON USER -->
  <ApplicationHeaderButton
    id="applicationUser"
    :buttonConfig="computedConfig"
    @click.native="showProfil()"
  />
</template>

<script>
import ApplicationHeaderButton from "./ApplicationHeaderButton";
export default {
  name: "ProfilButton",
  props: {
    profilConfig: { type: Object, default: () => {} }
  },
  computed: {
    computedConfig() {
      return Object.assign({}, this.profilConfig, {
        iconName: "dgfipicon-profil",
        text: "Mon profil",
        comment: this.$store.getters["user/fullname"]
      });
    }
  },
  methods: {
    showProfil() {
      this.$emit("profilButtonClick");
    }
  },
  components: {
    ApplicationHeaderButton
  }
};
</script>


